import React, { useState, useEffect } from 'react';
import { getDashboardStats } from '../services/api';
import './Dashboard.css';

function Dashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      setLoading(true);
      const data = await getDashboardStats();
      setStats(data);
    } catch (err) {
      setError(err.message || 'Fehler beim Laden der Statistiken');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading">Lade Dashboard...</div>;
  }

  if (error) {
    return <div className="error">{error}</div>;
  }

  return (
    <div className="dashboard">
      <h2>Übersicht</h2>
      <div className="stats-grid">
        <div className="stat-card">
          <h3>Benutzer</h3>
          <p className="stat-value">{stats?.total_users || 0}</p>
        </div>
        <div className="stat-card">
          <h3>Lizenzen</h3>
          <p className="stat-value">{stats?.total_licenses || 0}</p>
        </div>
        <div className="stat-card">
          <h3>Aktive Lizenzen</h3>
          <p className="stat-value">{stats?.active_licenses || 0}</p>
        </div>
        <div className="stat-card">
          <h3>Ausstehende Registrierungen</h3>
          <p className="stat-value">{stats?.pending_registrations || 0}</p>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;






